/* eslint-disable */
"use strict";
exports.__esModule = true;
exports.scaleSelector = void 0;
function scaleSelector(target) {
    return function (context) {
        var chart = context.chart, scale = context.scale;
        if (target === 'default') {
            return scale;
        }
        return chart.scales[target];
    };
}
exports.scaleSelector = scaleSelector;
